/* --------------------------------------------------------------------------------------

custom-collection-producut-grid-tab.liquid
商品一覧 / アーティスト詳細

main-search.liquid
検索結果

-------------------------------------------------------------------------------------- */

// タブ切り替えで絞り込み追加or削除とタブにactiveクラス付与

document.addEventListener('DOMContentLoaded', () => {

  // 絞り込みのカテゴリー非表示のためのクラス追加
  const category = document.querySelector('[id*="Details-filter.p.m.product.category"]');
  const categoryMobile = document.querySelector('[id*="Details-Mobile-filter.p.m.product.category"]');
  $(category).addClass("filter-product-category");
  $(categoryMobile).addClass("filter-product-category");

  const tabItems = document.querySelectorAll('.tabs .tab_item');

  function tablink() {
    
    const allLink = document.getElementById("all");
    const photoLink = document.getElementById("photo");
    const illustrationLink = document.getElementById("illustration");

    const nowURL = window.location.href;
    const nowURLja = decodeURIComponent(nowURL); // URLの文字化けを日本語に直す
    allLink.href = nowURLja;
    $(tabItems).removeClass("active");

    // URLに?が入っている時（すでに他の絞り込みがある時orアーティスト詳細ページか検索ページの時）
    if (nowURLja.includes("?")) {
        
      const photoURL = nowURLja + "&filter.p.m.product.category=フォト";
      const illURL = nowURLja + "&filter.p.m.product.category=イラスト";
      photoLink.href = photoURL;
      illustrationLink.href = illURL;
        
      if (nowURLja.includes("filter.p.m.product.category=フォト")) {
        $(photoLink).addClass("active");
        const illURL2 = nowURLja.replace("filter.p.m.product.category=フォト", "filter.p.m.product.category=イラスト");// フォトの絞り込みをイラストの絞り込みに置換
        illustrationLink.href = illURL2;
        const allURL = nowURLja.replace("filter.p.m.product.category=フォト", "");// フォトの絞り込みを削除
        allLink.href = allURL;
      } else if (nowURLja.includes("filter.p.m.product.category=イラスト")) {
        $(illustrationLink).addClass("active");
        const photoURL2 = nowURLja.replace("filter.p.m.product.category=イラスト", "filter.p.m.product.category=フォト");// イラストの絞り込みをフォトの絞り込みに置換
        photoLink.href = photoURL2;
        const allURL = nowURLja.replace("filter.p.m.product.category=イラスト", "");// イラストの絞り込みを削除
        allLink.href = allURL;
      } else {
        $(allLink).addClass("active");
      };

    } else {
        
      $(allLink).addClass("active");
      const photoURL = nowURLja + "?filter.p.m.product.category=フォト";
      const illURL = nowURLja + "?filter.p.m.product.category=イラスト";
      photoLink.href = photoURL;
      illustrationLink.href = illURL;
        
    };
  };

  // タブをクリックした時
  tabItems.forEach(item => {
    item.addEventListener('click', function() {
      
      tablink();
      
    });
  });

  // ページを読み込んだ時
  window.onload = function() {

    tablink();
    
  };
      
    
  });